import OpeningHoursIcon from '@mui/icons-material/AccessTime';

export default OpeningHoursIcon;
